import { useQuery } from '@tanstack/react-query';
import type { ApplyAttempt } from '@/lib/api';
import { fetchLatestApplyAttempt } from '@/server/applications.functions';

export type { ApplyAttempt } from '@/lib/api';

const POLL_INTERVAL_MS = 2500;

export const useApplyAttempt = (applicationId: number | null) =>
  useQuery({
    enabled: applicationId != null,
    queryFn: () => {
      if (applicationId == null) {
        throw new Error('Application id is required');
      }

      return fetchLatestApplyAttempt({
        data: { applicationId },
      }) as Promise<ApplyAttempt | null>;
    },
    queryKey: ['applyAttempt', applicationId],
    refetchInterval: (query) => {
      const status = query.state.data?.status;
      return status === 'running' || status === 'queued'
        ? POLL_INTERVAL_MS
        : false;
    },
  });
